import { exec } from "jadelet"
export default exec(["patterns",{},[{"bind":"patterns"}]])